import 'brace/ext/language_tools';
import 'brace/ext/searchbox';
import 'brace/mode/python';
import 'brace/mode/sql';
import {createStyles} from '@mantine/core';
import React from 'react';
import AceEditor from 'react-ace';

import {CustomComponentEditorProps} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';

import {PYTHON_STARTER_CODE} from './StarterCode';

export type CodeEditorMode = 'python' | 'sql';

const DEFAULT_VALUE: Record<CodeEditorMode, string> = {
  python: PYTHON_STARTER_CODE,
  sql: '',
};

interface UserDefinedFunctionEditorProps extends CustomComponentEditorProps {
  fieldName: string;
  mode?: CodeEditorMode;
}

const useStyles = createStyles(() => ({
  editorWrapper: {
    width: '100%',
    height: 'calc(100vh - 320px)',
    minHeight: 300,
  },
}));

export default function UserDefinedFunctionEditor({
  config: fullConfig,
  onChangeConfig,
  disabled,
  fieldName,
  mode = 'python',
}: UserDefinedFunctionEditorProps): JSX.Element {
  const {classes} = useStyles();
  const value = (fullConfig[fieldName] as string | null) ?? DEFAULT_VALUE[mode];

  const handleChange = (newValue: string): void => {
    onChangeConfig(fullConfig, [fieldName], newValue);
  };

  return (
    <div className={classes.editorWrapper}>
      <AceEditor
        value={value}
        onChange={handleChange}
        mode={mode}
        readOnly={disabled}
        showGutter={true}
        showPrintMargin={false}
        wrapEnabled={true}
        width="100%"
        height="100%"
      />
    </div>
  );
}
